<template>
  <div style="width:100%;height:100%;margin:0 auto;">
    <el-button
        type="info"
        style="background-color: #008a2c"
        icon="el-icon-back"
        circle
        @click="router"
      ></el-button>
      <div
      style="
        width: 100%;
        text-align: center;
        font-size: 25px;
        font-weight: bold;
      "
    >
      毕业生档案去向查询
    </div>
    <!-- <el-row :gutter="0" class="eltable">
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">姓名</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amusername}}</div>
      </el-col>
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">学号</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amuserid}}</div>
      </el-col>
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">院系</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amuserdepartname}}</div>
      </el-col>
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">专业</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amusermajor}}</div>
      </el-col>
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">班级</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amuserclass}}</div>
      </el-col>
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">联系方式</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amusertel}}</div>
      </el-col>`
    </el-row> -->
    <div
        style="
            margin-top: 30px;
            justify-content: center;
            margin-left: 5%;
            margin-right: 5%;
          "
      >
        <el-row justify="center" align="middle" style>
          <el-col :span="2">
            <div class="trcol">预约人</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusername }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">学号/工号</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserid }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">院系/部门</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserdepartname }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="trcol">专业</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusermajor != null ? userInfo.amusermajor : " " }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">班级</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserclass != null ? userInfo.amuserclass : " " }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">手机号码</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusertel }}</div>
          </el-col>
        </el-row>
      </div>
      <div class="form">
    <el-row :gutter="0" class="eltable">
      <el-col :span="3">
        <div class="eltableBackground bggray2 fb tc">毕业去向</div>
      </el-col>
      <el-col :span="21">
        <div class="gridContent">{{graduateFile.graduateDestination}}</div>
      </el-col>
      <el-col :span="3">
        <div class="eltableBackground bggray2 fb tc">档案转寄单位名称</div>
      </el-col>
      <el-col :span="21">
        <div class="gridContent">{{graduateFile.unitName}}</div>
      </el-col>
      <el-col :span="3">
        <div class="eltableBackground bggray2 fb tc">档案转寄地址</div>
      </el-col>
      <el-col :span="21">
        <div class="gridContent">{{graduateFile.unitAdress}}</div>
      </el-col>
      <el-col :span="3">
        <div class="eltableBackground bggray2 fb tc">档案转寄邮编</div>
      </el-col>
      <el-col :span="21">
        <div class="gridContent">{{graduateFile.unitZipCode}}</div>
      </el-col>
      <el-col :span="3">
        <div class="eltableBackground bggray2 fb tc">档案转寄联系电话</div>
      </el-col>
      <el-col :span="21">
        <div class="gridContent">{{graduateFile.unitTelephone}}</div>
      </el-col>
      <el-col :span="3">
        <div class="eltableBackground bggray2 fb tc">学院</div>
      </el-col>
      <el-col :span="21">
        <div class="gridContent">{{graduateFile.college}}</div>
      </el-col>
      <el-col :span="3">
        <div class="eltableBackground bggray2 fb tc">拓展项1</div>
      </el-col>
      <el-col :span="21">
        <div class="gridContent">{{graduateFile.f6}}</div>
      </el-col>
      <el-col :span="3">
        <div class="eltableBackground bggray2 fb tc">拓展项2</div>
      </el-col>
      <el-col :span="21">
        <div class="gridContent">{{graduateFile.f7}}</div>
      </el-col>
      <el-col :span="3">
        <div class="eltableBackground bggray2 fb tc">拓展项3</div>
      </el-col>
      <el-col :span="21">
        <div class="gridContent">{{graduateFile.f8}}</div>
      </el-col>
      <el-col :span="3">
        <div class="eltableBackground bggray2 fb tc">拓展项4</div>
      </el-col>
      <el-col :span="21">
        <div class="gridContent">{{graduateFile.f9}}</div>
      </el-col>
      <el-col :span="3">
        <div class="eltableBackground bggray2 fb tc">拓展项5</div>
      </el-col>
      <el-col :span="21">
        <div class="gridContent">{{graduateFile.f10}}</div>
      </el-col>
    </el-row>
      </div>
    <el-button
      type="success"
      class="button-wrapper"
      @click="router"
      style="margin-left: 50%;margin-top: 25px"
    >返回大厅首页</el-button>
  </div>
</template>

<script>
import { uploadPath, fileAcquisition } from "@/config/net.config.js";
import { queryGraduateFile } from "@/api/graduateFile";
import "@/static/css/my.css";
import { ipURL} from "@/config/net.config.js";
import { mapGetters } from "vuex";

export default {
  name: "serviceInfor",
  data() {
    return {
      isFollow: 0,
      activeName: "first",
      score: 3.7,
      infoData: [],
      ipURL: ipURL,
      showBtn: false, // 我要办事按钮是否可见,true 可见
      serviceId: "",
      url:
        "",
      uploadPath: uploadPath,
      fileAcquisition: fileAcquisition,
      userInfo: {
        amuserid: "",
        amusername: "",
        amusertel: "",
        amuserdepartcode: "",
        amuserdepartname: "",
        amusermajor: "",
        amusergrade: "",
        amuserclass: ""
      },
      graduateFile: {
        college: "",
        f6: "",
        f7: "",
        f8: "",
        f9: "",
        f10: "",
        unitAdress: "",
        unitName: "",
        unitTelephone: "",
        unitZipCode: "",
        userid: "",
        graduateDestination: ""
      }
    };
  },
  computed: {
    ...mapGetters(["getUserId", "getUserInfo"])
  },
  async mounted() {
    let testuserInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    this.userInfo = {
      amuserid: testuserInfo.userid,
      amusername: testuserInfo.name,
      amusertel: testuserInfo.amusertel,
      amuserdepartcode: testuserInfo.amuserdepartcode,
      amuserdepartname: testuserInfo.department,
      amusermajor: testuserInfo.major,
      amuserclass: testuserInfo.bj
    };
    console.log("我的数据    ", this.userInfo);
    let data = await queryGraduateFile(this.userInfo.amuserid);
    console.log("list数据", data);
    console.log("data", data.data);
    if (data.data != null && data.data !== undefined) {
      this.graduateFile = {
        college: data.data.college,
        f6: data.data.f6,
        f7: data.data.f7,
        f8: data.data.f8,
        f9: data.data.f9,
        f10: data.data.f10,
        unitAdress: data.data.unitAdress,
        unitName: data.data.unitName,
        unitTelephone: data.data.unitTelephone,
        unitZipCode: data.data.unitZipCode,
        userid: data.data.userid,
        graduateDestination: data.data.graduateDestination
      };
    }
  },
  methods: {
    router() {
      this.$router.push("/");
    }
  },
  components: {
    // HelloWorld
  }
};
</script>
<style scoped>
.trcol {
  background-color: #d8efbf;
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.tdcol {
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
}
.form {
  margin-left: 5%;
  /* border:1px solid #dddddd; */
  margin-top: 30px;
  /* padding: 20px; */
  margin-right: 5%;
}
.el-tabs__item.is-active {
  color: #2c3e50 !important;
  font-weight: bold;
}

.eltable {
  /* border-left: 1px solid #dddddd; */
  margin-top: 20px;
  border-top: 1px solid #dddddd;
}

.eltable .gridContent {
  padding: 10px 8px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 19px;
  font-size: 14px;
}

.eltableBackground {
  background: rgba(155, 213, 91, 0.39);
  padding: 10px 8px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 19px;
  font-size: 14px;
}

.el-rate__icon {
  font-size: 28px;
}

.button .button-wrapper,
.button_solid .button-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: inherit;
  align-items: inherit;
  margin-right: 20px;
}

/**我要收藏，取消收藏 按钮 样式 start */
.el-button.is-circle {
  border-radius: 50%;
  padding: 8px;
}

.isfollow {
  font-size: 20px;
  color: red;
}

.isfollow:hover {
  font-size: 20px;
  color: white;
}

.nofollow {
  font-size: 20px;
  color: white;
}

.nofollow:hover {
  font-size: 20px;
  color: red;
}

/**我要收藏，取消收藏 按钮 样式 end */

.other:hover {
  color: white;
}

</style>